module.exports = __webpack_public_path__ + "static/speaker2-b71add2fd7d08321f8364ea4828cb942.jpg";